import type { BillingCycle } from './api';

/**
 * Constantes de exibicao dos ciclos de cobranca. O PRECO de cada ciclo eh
 * dinamico (vem do backend - Plan.priceCents para o mensal, PlanPrice para os
 * longos). Aqui ficam apenas o rotulo, os meses e o calculo do desconto
 * emergente - nenhum percentual fixo de negocio.
 */
export const CYCLE_MONTHS: Record<BillingCycle, number> = {
  MONTHLY: 1,
  SEMIANNUAL: 6,
  ANNUAL: 12,
};

export const CYCLE_LABEL: Record<BillingCycle, string> = {
  MONTHLY: 'Mensal',
  SEMIANNUAL: 'Semestral',
  ANNUAL: 'Anual',
};

/** Sufixo curto para precos por ciclo (ex.: "R$ 299,70/semestre"). */
export const CYCLE_PER_LABEL: Record<BillingCycle, string> = {
  MONTHLY: '/mês',
  SEMIANNUAL: '/semestre',
  ANNUAL: '/ano',
};

/** Ciclos longos (editaveis em /admin/plans; mensal mora no proprio plano). */
export const LONG_CYCLES: ReadonlyArray<'SEMIANNUAL' | 'ANNUAL'> = [
  'SEMIANNUAL',
  'ANNUAL',
];

/**
 * Desconto emergente do ciclo: quanto se economiza pagando o ciclo em vez de
 * pagar o mensal N vezes. Retorna % inteiro (>=1) ou null quando nao ha ganho.
 */
export function cycleDiscountPercent(
  monthlyCents: number,
  cycleCents: number,
  cycle: BillingCycle,
): number | null {
  const months = CYCLE_MONTHS[cycle];
  if (months <= 1 || monthlyCents <= 0 || cycleCents <= 0) return null;
  const full = monthlyCents * months;
  if (cycleCents >= full) return null;
  const pct = Math.round(((full - cycleCents) / full) * 100);
  return pct >= 1 ? pct : null;
}

/** Equivalente mensal (em centavos) de um preco de ciclo - para comparacao. */
export function cycleMonthlyEquivalentCents(
  cycleCents: number,
  cycle: BillingCycle,
): number {
  return Math.round(cycleCents / CYCLE_MONTHS[cycle]);
}
